import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { EmailAccountSelectField } from '../EmailAccountSelectField'
import { EMAIL_CREATION_FORM_FIELD_NAME_FROM } from '../EmailCreationForm.constants'

import { getFromFieldAccountApiParams } from './FromField.utils'

function FromField({ fieldProps = EMPTY_OBJECT, label, mass, placeholder }) {
  const { t } = useTranslation()

  const {
    mass: massFieldProps,
    withServiceAccount = false,
    ...restFieldProps
  } = fieldProps

  return (
    <EmailAccountSelectField
      {...restFieldProps}
      apiParams={getFromFieldAccountApiParams({
        mass: massFieldProps ?? mass,
        withServiceAccount,
      })}
      label={label || `${t('Email.FromLabelKey')}:`}
      name={EMAIL_CREATION_FORM_FIELD_NAME_FROM}
      placeholder={placeholder || t('Email.FromPlaceholderKey')}
    />
  )
}

export default FromField
